export default __webpack_public_path__ + "static/media/helpful-selected-reaction.c030e63a.svg";